import styled, { css } from 'styled-components';

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  
  ${props => {
    switch (props.type) {
      case 'live':
        return css`
          background-color: #e8f5e9;
          color: #4caf50;
        `;
      case 'recorded':
        return css`
          background-color: #e3f2fd;
          color: #2196f3;
        `;
      case 'hybrid':
        return css`
          background-color: #fff3e0;
          color: #ff9800;
        `;
      case 'in-person':
        return css`
          background-color: #f3e5f5;
          color: #9c27b0;
        `;
      default:
        return css`
          background-color: #f5f5f5;
          color: #757575;
        `;
    }
  }};
`;

export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background-color: ${props => props.theme.colors.primary};
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 0.5rem;
`;

const BadgeComponents = {
  Badge,
  CountBadge
};

export default BadgeComponents;
